import { Box, Stack, Typography } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function PercentageIndicator({ value }) {
  const getColor = (value) => {
    if (value > 0) return "#61B477";
    if (value < 0) return "#D32F2F";
    return "rgba(0, 0, 0, 0.87)";
  };

  const getArrow = (value) => {
    if (value > 0) return "up";
    if (value < 0) return "down";
    return "";
  };

  const displayColor = getColor(value);

  const ArrowIcon =
    getArrow(value) === "up" ? ArrowDropUpIcon : ArrowDropDownIcon;

  if (!value) return null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "100%",
        position: "relative",
      }}
      spacing={2}
    >
      <Box
        sx={{
          position: "absolute",
          right: "50%",
          transform: `translateX(calc(-40% - 2px))`,
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <ArrowIcon sx={{ color: displayColor }} fontSize="small" />
      </Box>
      <Typography
        sx={{
          color: displayColor,
          fontFamily: "Roboto",
          fontSize: "14px",
          fontWeight: "400",
          padding: "1px",
          textAlign: "center",
        }}
      >
        {value ? `${value}%` : "N/A"}
      </Typography>
    </Stack>
  );
}
